@if(comment){
<div class="row">
  <div class="col-md-6">
    <div>
      <div class="card shadow-sm ">
        <div class="card-header with-border">
          Comment
        </div>
        <div class="card-body">
          <div>
          <form #commentForm="ngForm"
            class="form-horizontal">
            <div class="form-group row">
              <div class="col-md-12">
                <app-material-date-range
                  id="selectedDate"
                  name="incidentDate"
                  [singleDateSelector]="true"
                  [(dateRange)]="_selectedDate"
                  [timePicker]="true"
                  [placeholder]="'Date & time'"
                  [localeDateFormat]="'YYYY-MM-DD HH:mm'">
                </app-material-date-range>
              </div>
            </div>
            <div class="form-group row">
              <app-material-chunk-file-uploader
                [accept]="'.pdf'"
                name="document"
                [ngModel]="doc"
                (ngModelChange)="uploadDocument($event)">
              </app-material-chunk-file-uploader>
            </div>
            <div class="form-group row">
              <mat-form-field class="col-md-12" appearance="outline">
                <mat-label>Comment</mat-label>
                <textarea
                  matInput
                  id="comment"
                  name="comment"
                  rows="5"
                  cols="40"
                  [(ngModel)]="comment.content"
                  required>
                </textarea>
              </mat-form-field>
            </div>
            <div class="btn-group pull-right mt-2" role="group" aria-label="Button group">
              <app-material-pg-button
                id="cancel"
                class="me-1"
                (clicked)="backToVoyage()"
                label="Back to voyage">
              </app-material-pg-button>
              <app-material-pg-button
                id="save"
                (clicked)="saveComment()"
                label="Save"
                [disabled]="!commentForm.form.valid">
              </app-material-pg-button>
            </div>
          </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div>
      <app-material-pdf-viewer [fileId]?="comment.fileId"> </app-material-pdf-viewer>
    </div>
  </div>
</div>
}